import type { SelectTokenType } from '@/components/Header/TokenBalance';
import { type TokenInfo, tokens } from '@/config/tokens';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Group, Image, Input, NumberFormatter, Paper, ScrollArea, Stack, Text } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useState } from 'react';
import classes from './AccountBalance.module.css';
export const data: Record<TokenInfo['symbol'], {
  readonly balance: number;
  readonly value: number;
}> = {
  BTC: {
    balance: 25000,
    value: 0.55226
  },
  USDT: {
    balance: 1125,
    value: 1.125
  },
  ETH: {
    balance: 2950,
    value: 1.255265
  },
  LTC: {
    balance: 0,
    value: 0
  },
  PRLL: {
    balance: 0,
    value: 0
  },
  SOL: {
    balance: 0,
    value: 0
  }
};
export type AccountBalanceProps = {
  setSelectedToken: (token: SelectTokenType) => void;
  setOpened: (opened: boolean) => void;
};
export const AccountBalance: React.FC<AccountBalanceProps> = ({
  setSelectedToken,
  setOpened
}) => {
  const {
    i18n
  } = useLingui();
  const [searchValue, setSearchValue] = useState<TokenInfo[]>(tokens);
  const handleSearch = (searchValue: string) => {
    const tokenList = tokens.filter(token => token.symbol.toLowerCase().includes(searchValue.toLowerCase()));
    setSearchValue(tokenList);
  };
  const handleItemClick = (token: TokenInfo) => {
    setSelectedToken({
      tokenURI: token.logoURI,
      symbol: token.symbol,
      ...data[token.symbol]
    });
    setOpened(false);
  };
  return <>
      <Stack gap={20} p={15}>
        <Input onChange={e => handleSearch(e.target.value)} size="md" placeholder={i18n._('Search')} tt="uppercase" classNames={{
        input: classes.searchInput
      }} rightSection={<IconSearch />} />

        <Group justify="space-between" align="center" px={10}>
          <Text tt="uppercase" fz="xs" fw="bold" c="prime.11">
            {i18n._('Crypto')}
          </Text>
          <Text tt="uppercase" fz="xs" fw="bold" c="prime.11">
            {i18n._('Wallet')}
          </Text>
        </Group>
        <ScrollArea h={400} mt={-10}>
          {searchValue.length ? searchValue.map(token => <Paper key={token.symbol} radius="md" p="xs" className={classes.balanceList} onClick={() => handleItemClick(token)}>
                <Group justify="space-between" align="center">
                  <Group gap={10} align="center">
                    <Image src={token.logoURI} alt={token.symbol} className={classes.logo} w={45} h={45} />
                    <Stack gap={0}>
                      <Text fz={14} className={gunterzBold.className} fw="bold">
                        {token.symbol}
                      </Text>
                      <Text mt={-5} c="prime.11" fz="sm">
                        ({token.name})
                      </Text>
                    </Stack>
                  </Group>
                  <Group gap={10} align="center">
                    <Stack gap={0} align="end">
                      <Text fw="bold" c="var(--text-green)" fz={14}>
                        <NumberFormatter prefix="$" value={data[token.symbol].balance} thousandSeparator fixedDecimalScale decimalScale={2} />
                      </Text>
                      <Text fz={14} c="prime.11">
                        <NumberFormatter prefix="" value={data[token.symbol].value} fixedDecimalScale thousandSeparator decimalScale={2} />
                      </Text>
                    </Stack>
                  </Group>
                </Group>
              </Paper>) : <Text ta="center" fz="sm">
              {i18n._('There are no search results')}
            </Text>}
        </ScrollArea>
      </Stack>
    </>;
};